import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { NumberTextBoxWithUnit } from './NumberTextBoxWithUnit'
import { OpeningCondition } from '../SearchConditionList'
import { OneThousandYen } from './OneThousandYen'
import { RandgeCondition } from '../../../../types'
import { CheckBox } from './Checkbox'
import { SearchCondition } from './SearchCondition'

type Props = {
  preValuationFrom: number | null
  setPreValuationFrom: React.Dispatch<React.SetStateAction<number | null>>
  preValuationTo: number | null
  setPreValuationTo: React.Dispatch<React.SetStateAction<number | null>>
  opening: boolean
  setOpeningCondition: React.Dispatch<React.SetStateAction<OpeningCondition>>
}

export const PreValuationFilter: React.FC<Props> = (props) => {
  const presetConditions: RandgeCondition[] = [
    { label: '5百万円以下', range: { from: null, to: 5000 } },
    { label: '5百万円以上', range: { from: 5000, to: null } },
    { label: '1千万円以上', range: { from: 10000, to: null } },
    { label: '5千万円以上', range: { from: 50000, to: null } },
    { label: '1億円以上', range: { from: 100000, to: null } },
    { label: '3億円以上', range: { from: 300000, to: null } },
    { label: '5億円以上', range: { from: 500000, to: null } },
  ]

  const isSelectedPreset = (presetCondition: RandgeCondition) => {
    return (
      presetCondition.range.from === props.preValuationFrom &&
      presetCondition.range.to === props.preValuationTo
    )
  }

  const handlePresetSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedConditionLabel: RandgeCondition['label'] = e.target.value
    const selectedPresetCondition = presetConditions.find((presetCondition) => {
      return presetCondition.label === selectedConditionLabel
    })
    if (selectedPresetCondition) {
      props.setPreValuationFrom(selectedPresetCondition.range.from)
      props.setPreValuationTo(selectedPresetCondition.range.to)
    }
  }

  const handlePreValuationFromChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const val = Number(e.target.value)
    props.setPreValuationFrom(val)
  }

  const handlePreValuationToChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const val = Number(e.target.value)
    props.setPreValuationTo(val)
  }

  return (
    <SearchCondition
      title="調達前評価額"
      selected={!!(props.preValuationFrom || props.preValuationTo)}
      opening={props.opening}
      toggleOpen={() => {
        if (props.opening) {
          props.setOpeningCondition(null)
        } else {
          props.setOpeningCondition('PreValuation')
        }
      }}
    >
      {presetConditions.map((presetCondition, i) => {
        return (
          <CheckBox
            key={i}
            name="preValuation"
            value={presetCondition.label}
            handler={handlePresetSelected}
            checked={isSelectedPreset(presetCondition)}
          >
            {presetCondition.label}
          </CheckBox>
        )
      })}
      <div
        css={css`
          border-top: 1px solid ${colors.borderLight};
          padding: 15px 10px;
          display: flex;
          justify-content: space-around;
        `}
      >
        <NumberTextBoxWithUnit
          placeholder="From"
          handler={handlePreValuationFromChange}
          value={props.preValuationFrom}
        >
          <OneThousandYen />
        </NumberTextBoxWithUnit>
        <span
          css={css`
            display: inline-block;
            color: ${colors.gray90};
          `}
        >
          -
        </span>
        <NumberTextBoxWithUnit
          placeholder="To"
          handler={handlePreValuationToChange}
          value={props.preValuationTo}
        >
          <OneThousandYen />
        </NumberTextBoxWithUnit>
      </div>
    </SearchCondition>
  )
}
